import React, {useContext} from 'react';
import {Container, Navbar, Nav, Dropdown} from 'react-bootstrap';
import { AppContext } from '../App';


export const MainNavbar=()=>{
	const { setPage, user, getExpired, getQuickLinks, getQuickReport, getEnquiry  } = useContext(AppContext);	
	return(
		<Navbar expand="lg" className="main-nav" >
      <Container fluid>
        <Navbar.Brand className="nav-brand" onClick={()=>{setPage('home')}} >AMS</Navbar.Brand>
	        <Navbar.Toggle aria-controls="navbarScroll" />
	        <Navbar.Collapse id="navbarScroll">
	          <Nav className="me-auto my-2 my-lg-0" navbarScroll >
	          	<Nav.Link onClick={()=>{ 
	          		setPage('home');
	          		getQuickReport();
	          		}} >Home</Nav.Link>
	          	<Nav.Link onClick={()=>{ 
	          		setPage('accounts');
	          		getExpired();
	          		}} >Accounts</Nav.Link>
	          		<Nav.Link onClick={()=>{
	          			getQuickLinks();
	          			setPage('quick_links');
	          		}} >Quick links</Nav.Link>
					      <Nav.Link onClick={()=>{
					      	getEnquiry();
					      	setPage('enquiry');
					      }} >Enquiry</Nav.Link>
	        </Nav>
			    <Dropdown align='end' >
	            <Dropdown.Toggle variant="outline-secondary" id="dropdown-menu-align-end" className="menu1" >
	              {
	              	user!==undefined&&user.username!==undefined?user.username:'Username'
	              }
	            </Dropdown.Toggle>
	            <Dropdown.Menu className="menu-one" >
	              <Dropdown.Item eventKey="4" onClick={()=>{
	                localStorage.clear();
	                window.location.reload();
	                }} >
	                <span className="menu-icon" ><i className="bi bi-box-arrow-left"></i></span>
	                <span className="menu-name" >Log out</span>
	              </Dropdown.Item>
	            </Dropdown.Menu>
	        </Dropdown>
        </Navbar.Collapse>
      </Container>
    </Navbar>
		)
}